import { useCallback, useState } from 'react';
import {
  KiemTraTinhTrangHoaDonDienTuDbItem,
  KiemTraTinhTrangHoaDonDienTuResponse,
  KiemTraTinhTrangHoaDonDienTuSearchFormValues,
  UseKiemTraTinhTrangHoaDonDienTuReturn
} from '@/types/schemas';
import api from '@/lib/api';

const generateMockData = (): KiemTraTinhTrangHoaDonDienTuDbItem[] => {
  return [
    {
      id: '1',
      ma_ct: 'HDB',
      unit_id: 'CN_HN',
      so_ct: 'HDB2024001',
      ngay_ct: '2024-01-15',
      ten_ct: 'Hóa đơn bán hàng',
      ma_tthddt: 'Đã xác thực',
      ma_kh: 'KH001',
      ten_kh_thue: 'Công ty TNHH ABC Technology',
      ma_so_thue: '0123456789',
      dia_chi: '123 Đường ABC, Quận Ba Đình, Hà Nội',
      t_tt_nt: 50000000,
      dien_thoai: '024-1234567',
      e_mail: 'contact@abc-tech.com',
      tknh: '1234567890',
      ten_nh: 'Ngân hàng TMCP Đầu tư và Phát triển Việt Nam',
      ma_pttt: 'CK',
      noi_dung: 'Bán phần mềm quản lý doanh nghiệp',
      van_ban_thoa_thuan: 'Hợp đồng số 001/2024',
      ngay_thoa_thuan: '2024-01-10',
      ma_nt: 'VND'
    },
    {
      id: '2',
      ma_ct: 'HDB',
      unit_id: 'CN_HCM',
      so_ct: 'HDB2024002',
      ngay_ct: '2024-01-16',
      ten_ct: 'Hóa đơn bán hàng',
      ma_tthddt: 'Chờ xác thực',
      ma_kh: 'KH002',
      ten_kh_thue: 'Cửa hàng XYZ Trading',
      ma_so_thue: '0987654321',
      dia_chi: '456 Đường XYZ, Quận 1, TP.HCM',
      t_tt_nt: 25000000,
      dien_thoai: '028-9876543',
      e_mail: 'info@xyz-trading.com',
      tknh: '0987654321',
      ten_nh: 'Ngân hàng TMCP Ngoại thương Việt Nam',
      ma_pttt: 'TM',
      noi_dung: 'Bán thiết bị văn phòng',
      van_ban_thoa_thuan: 'Hợp đồng số 002/2024',
      ngay_thoa_thuan: '2024-01-12',
      ma_nt: 'VND'
    },
    {
      id: '3',
      ma_ct: 'HDB',
      unit_id: 'CN_DN',
      so_ct: 'HDB2024003',
      ngay_ct: '2024-01-17',
      ten_ct: 'Hóa đơn bán hàng',
      ma_tthddt: 'Đã hủy',
      ma_kh: 'KH003',
      ten_kh_thue: 'Doanh nghiệp tư nhân DEF',
      ma_so_thue: '1122334455',
      dia_chi: '789 Đường DEF, Quận Hải Châu, Đà Nẵng',
      t_tt_nt: 75000000,
      dien_thoai: '0236-1122334',
      e_mail: 'sales@def-enterprise.com',
      tknh: '1122334455',
      ten_nh: 'Ngân hàng TMCP Công thương Việt Nam',
      ma_pttt: 'CK',
      noi_dung: 'Bán máy móc thiết bị',
      van_ban_thoa_thuan: 'Hợp đồng số 003/2024',
      ngay_thoa_thuan: '2024-01-14',
      ma_nt: 'VND'
    },
    {
      id: '4',
      ma_ct: 'HDB',
      unit_id: 'CN_HN',
      so_ct: 'HDB2024004',
      ngay_ct: '2024-01-18',
      ten_ct: 'Hóa đơn bán hàng',
      ma_tthddt: 'Đã thay thế',
      ma_kh: 'KH004',
      ten_kh_thue: 'Công ty Cổ phần GHI Solutions',
      ma_so_thue: '5566778899',
      dia_chi: '321 Đường GHI, Quận Cầu Giấy, Hà Nội',
      t_tt_nt: 120000000,
      dien_thoai: '024-5566778',
      e_mail: 'business@ghi-solutions.com',
      tknh: '5566778899',
      ten_nh: 'Ngân hàng TMCP Á Châu',
      ma_pttt: 'CK',
      noi_dung: 'Bán dịch vụ tư vấn IT',
      van_ban_thoa_thuan: 'Hợp đồng số 004/2024',
      ngay_thoa_thuan: '2024-01-16',
      ma_nt: 'VND'
    },
    {
      id: '5',
      ma_ct: 'HDB',
      unit_id: 'CN_HCM',
      so_ct: 'HDB2024005',
      ngay_ct: '2024-01-19',
      ten_ct: 'Hóa đơn bán hàng',
      ma_tthddt: 'Đã điều chỉnh',
      ma_kh: 'KH005',
      ten_kh_thue: 'Cửa hàng JKL Retail',
      ma_so_thue: '9988776655',
      dia_chi: '654 Đường JKL, Quận 3, TP.HCM',
      t_tt_nt: 35000000,
      dien_thoai: '028-9988776',
      e_mail: 'contact@jkl-retail.com',
      tknh: '9988776655',
      ten_nh: 'Ngân hàng TMCP Sài Gòn Thương Tín',
      ma_pttt: 'TM',
      noi_dung: 'Bán hàng tiêu dùng',
      van_ban_thoa_thuan: 'Hợp đồng số 005/2024',
      ngay_thoa_thuan: '2024-01-17',
      ma_nt: 'VND'
    }
  ];
};

/**
 * Custom hook for managing KiemTraTinhTrangHoaDonDienTu (Electronic Invoice Status Check) data
 *
 * This hook provides functionality to fetch electronic invoice status data
 * with mock support for testing and development purposes.
 */
export function useKiemTraTinhTrangHoaDonDienTu(
  searchParams: KiemTraTinhTrangHoaDonDienTuSearchFormValues
): UseKiemTraTinhTrangHoaDonDienTuReturn {
  const [data, setData] = useState<BanHangRecord[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = useCallback(async (searchParams: KiemTraTinhTrangHoaDonDienTuSearchFormValues) => {
    setIsLoading(true);
    setError(null);

    try {
      const mockDbData = generateMockData();

      // Simulate API call
      await api.get<KiemTraTinhTrangHoaDonDienTuResponse>('/ban-hang/hoa-don-dien-tu/kiem-tra-tinh-trang/', {
        mock: true,
        mockData: mockDbData,
        params: searchParams
      });

      // Use database field data directly for the table
      setData(mockDbData);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred while fetching data';
      setError(new Error(errorMessage));
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const refreshData = useCallback(async () => {
    await fetchData(searchParams);
  }, [fetchData, searchParams]);

  return {
    data,
    isLoading,
    error,
    fetchData,
    refreshData
  };
}
